import { render } from "./NotificationEditor.vue?vue&type=template&id=4a723f00&scoped=true"
import script from "./NotificationEditor.vue?vue&type=script&lang=js"
export * from "./NotificationEditor.vue?vue&type=script&lang=js"

import "./NotificationEditor.vue?vue&type=style&index=0&id=4a723f00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a723f00"]])

export default __exports__